webpackJsonp([10],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(203);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(167)("9792db78", content, true);

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(166)(true);
// imports


// module
exports.push([module.i, ".user-bg[data-v-5cfb0e37]{position:relative;height:4rem;margin-bottom:1.6rem;background:-webkit-linear-gradient(left bottom,#e98a8b,#e26869);background:linear-gradient(to right top,#e98a8b,#e26869);box-shadow:0 .05333rem .18667rem 0 #e78081}.avatar[data-v-5cfb0e37]{position:absolute;left:50%;bottom:0;width:2.13333rem;height:2.13333rem;margin-bottom:-1.06667rem;margin-left:-1.06667rem;border-radius:50%}", "", {"version":3,"sources":["/opt/build/repo/src/views/My.vue"],"names":[],"mappings":"AACA,0BACE,kBAAmB,AACnB,YAAa,AACb,qBAAsB,AACtB,gEAAmE,AACnE,yDAA4D,AAC5D,0CAAoD,CACrD,AACD,yBACE,kBAAmB,AACnB,SAAU,AACV,SAAU,AACV,iBAAkB,AAClB,kBAAmB,AACnB,0BAA2B,AAC3B,wBAAyB,AACzB,iBAAmB,CAepB","file":"My.vue","sourcesContent":["\n.user-bg[data-v-5cfb0e37] {\n  position: relative;\n  height: 4rem;\n  margin-bottom: 1.6rem;\n  background: -webkit-linear-gradient(left bottom, #e98a8b, #e26869);\n  background: linear-gradient(to right top, #e98a8b, #e26869);\n  box-shadow: 0rem 0.05333rem 0.18667rem 0rem #e78081;\n}\n.avatar[data-v-5cfb0e37] {\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  width: 2.13333rem;\n  height: 2.13333rem;\n  margin-bottom: -1.06667rem;\n  margin-left: -1.06667rem;\n  border-radius: 50%;\n/*animation avatar 3s infinite linear\n\n@keyframes avatar\n  0%\n  100%\n    border-top-left-radius 50%\n    border-top-right-radius 65%\n    border-bottom-left-radius 69%\n    border-bottom-right-radius 50%\n  50%\n    border-top-left-radius 69%\n    border-top-right-radius 50%\n    border-bottom-left-radius 50%\n    border-bottom-right-radius 65%*/\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leancloud_storage__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leancloud_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leancloud_storage__);





/* harmony default export */ __webpack_exports__["default"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])({ storeLogout: 'logout' }), {
    logout: function logout() {
      var _this = this;

      this.$confirm('确认要退出当前系统么？').then(function () {
        _this.storeLogout();
        return __WEBPACK_IMPORTED_MODULE_2_leancloud_storage___default.a.User.logOut().then(function () {
          _this.$router.push('/auth');
        });
      }).catch(function () {});
    }
  })
});

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my"
  }, [_c('div', {
    staticClass: "user-bg"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.$store.getters.user.avatar,
      "alt": "avatar"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/my/avatar')
      }
    }
  })]), _vm._v(" "), _c('u-cell-group', {
    attrs: {
      "title": "个人信息"
    }
  }, [_c('u-cell', {
    attrs: {
      "text": "用户名",
      "value": _vm.$store.getters.user.username
    }
  }), _vm._v(" "), _c('u-cell', {
    attrs: {
      "text": "绑定邮箱",
      "value": _vm.$store.getters.user.email,
      "show-arrow": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/my/bind-email')
      }
    }
  }), _vm._v(" "), _c('u-cell', {
    attrs: {
      "text": "修改密码",
      "show-arrow": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/my/reset-password')
      }
    }
  }), _vm._v(" "), _c('u-cell', {
    attrs: {
      "text": "常用联系人",
      "show-arrow": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/my/contacts')
      }
    }
  }), _vm._v(" "), _c('u-cell', {
    attrs: {
      "text": "分类管理",
      "show-arrow": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/my/tags')
      }
    }
  })], 1), _vm._v(" "), _c('u-cell-group', {
    attrs: {
      "title": "其它"
    }
  }, [_c('u-cell', {
    attrs: {
      "text": "关于",
      "show-arrow": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/about')
      }
    }
  })], 1), _vm._v(" "), _c('u-button', {
    staticStyle: {
      "width": "80%",
      "margin": "40px 10% 20px"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(205),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5cfb0e37",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/10.79993a105ef49c6deaff.js